import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDuplicate$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDuplicate extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a96288d8679881527e86d57415d03c70d38c3626', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5baccb366a593a70da800468d15bfa2c109cb9d8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '615c3e903c92961ad53b646e150380b716dfcf6c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 3h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5M15 16.5a.5.5 0 0 0-.5-.5H14a.5.5 0 0 0-.5.5v1h-9v-9h1A.5.5 0 0 0 6 8v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5zm2-7.25a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-2.75V5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2.75H10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2.75V12a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V9.25z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-duplicate", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-duplicate"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-duplicate":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDuplicate$1);
            }
            break;
    } });
}

const CosmosIconDuplicate = CosmosIconDuplicate$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDuplicate, defineCustomElement };
